module.exports = __webpack_public_path__ + "img/96c8e11.jpg";